import _ from './utility'

const modal = {
    showModal: function (contentId) {
        const breakpoint = _.getBreakpoint();
        if (breakpoint !== 1) {
            moveLayer(contentId);
        }

        $('body').addClass('modal-layer-on');
        $('#' + contentId).removeClass('inactive').addClass('active');
        if (!$('#whiteoutLayer').length) {
            $('body').append('<div id="whiteoutLayer"></div>');
        }
        $('#whiteoutLayer').show();
    },

    hideModal: function (contentId) {
        $('#' + contentId).addClass('inactive').removeClass('active').css('top', '');
        $('body').removeClass('modal-layer-on');
        $('#whiteoutLayer').hide();
    }
}

function moveLayer (id) {
    let pos = null;
    if (window.innerHeight) {
        pos = window.pageYOffset
    } else if (document.documentElement && document.documentElement.scrollTop) {
        pos = document.documentElement.scrollTop
    } else if (document.body) {
        pos = document.body.scrollTop
    }

    (pos < 70) ? pos = 70 : pos += 50;
    document.getElementById(id).style.top = (pos + 'px');
}

export default modal